import { Component, input } from '@angular/core';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { IReportFilter } from '../../../../utils/interfaces/report-filter';
import { IAvailableTime, IUnit } from '../../../../utils/interfaces/unit';

@Component({
  selector: 'app-shifts',
  standalone: true,
  imports: [MatCheckboxModule],
  templateUrl: './shifts.component.html',
  styleUrl: './shifts.component.scss',
})
export class ShiftsComponent {
  filter = input.required<IReportFilter>();
  allUnits = input.required<IUnit[]>();

  handlerShift(shift: IAvailableTime): void {
    const shifts = this.filter().avaiableShifts || [];

    if (shifts.includes(shift.id!)) {
      this.filter().avaiableShifts = shifts.filter((S) => S !== shift.id);
      this.filter().avaiableShiftsDescription =
        this.filter().avaiableShiftsDescription?.filter(
          (s) =>
            s !==
            `${shift.description} ${shift.startTime}hs às ${shift.endTime}hs`
        );
    } else {
      this.filter().avaiableShifts = [...shifts, shift.id!];
      this.filter().avaiableShiftsDescription = [
        ...(this.filter().avaiableShiftsDescription ?? []),
        `${shift.description} ${shift.startTime}hs às ${shift.endTime}hs`,
      ];
    }
  }
}
